import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';

import { ButtonModule, DropdownModule, DropdownTriggerForDirective, IconModule, LetModule } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

import { PermissionsStore } from '@pp/core/store';

import { DialogComponent } from './dialog/dialog.component';

@Component({
  imports: [TranslateModule, AsyncPipe, LetModule, IconModule, ButtonModule, DropdownModule, DialogComponent],
  selector: 'pp-menu',
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent {
  readonly dropdown = viewChild(DropdownTriggerForDirective);

  permissions = inject(PermissionsStore);

  closeMenu(event: Event) {
    const target = event.target as HTMLElement;

    if (target.closest('pp-routing-item')) {
      this.dropdown().closeDropdown();
    }
  }
}
